import { useParams } from "react-router";
import { toPath, useIsCurrentRouteMatching, type Paths } from "../../../../router/helpers/path";

export type EventPaths = Extract<
  Paths,
  | "/projects/:projectId/fault-events/manual/:manualFaultEventId"
  | "/projects/:projectId/fault-events/:faultEventId"
>;
export type EventPathParameters = Parameters<typeof toPath<EventPaths>>[1];

export const useEventPath = () => {
  const { projectId, manualFaultEventId, faultEventId } = useParams();

  const faultEventPath = useIsCurrentRouteMatching([
    "/projects/:projectId/fault-events/:faultEventId",
    "/projects/:projectId/fault-events/:faultEventId/fault",
    "/projects/:projectId/fault-events/:faultEventId/symptom",
    "/projects/:projectId/fault-events/:faultEventId/data",
    "/projects/:projectId/fault-events/:faultEventId/dashboard/:dashboardId",
  ]);

  const manualFaultPath = useIsCurrentRouteMatching([
    "/projects/:projectId/fault-events/manual/:manualFaultEventId",
    "/projects/:projectId/fault-events/manual/:manualFaultEventId/fault",
    "/projects/:projectId/fault-events/manual/:manualFaultEventId/symptom",
    "/projects/:projectId/fault-events/manual/:manualFaultEventId/data",
    "/projects/:projectId/fault-events/manual/:manualFaultEventId/dashboard/:dashboardId",
  ]);

  let eventPath: EventPaths;
  let eventPathParameters: EventPathParameters;

  if (manualFaultPath && projectId && manualFaultEventId) {
    eventPath = "/projects/:projectId/fault-events/manual/:manualFaultEventId";
    eventPathParameters = { projectId, manualFaultEventId };
  } else if (faultEventPath && projectId && faultEventId) {
    eventPath = "/projects/:projectId/fault-events/:faultEventId";
    eventPathParameters = { projectId, faultEventId };
  } else {
    throw new Error("EventNavigation can't be used outside Fault Event routes.");
  }

  return { eventPath, eventPathParameters };
};
